import * as Api from '@ViewModels';
import { useState } from 'react';
import { css } from '../../../../../../../../surveys/components/Modal/styles';
import { PhoneNumberLabelCombobox } from '../../../../../../../components/entities/PhoneNumberLabelCombobox';
import { Input } from '../../../../../../../components-v2/Input';
import { styleSheet } from '../../styles';

export const PhoneNumberForm = ({
	onChange,
	phone,
}: {
	phone: Api.IPhoneNumber;
	onChange: (value: Api.IPhoneNumber) => void;
}) => {
	const [newPhoneNumber, setNewPhoneNumber] = useState<Api.IPhoneNumber>(phone);

	const handleLabelChange = (label: string) => {
		setNewPhoneNumber(prev => {
			const updated = { ...prev, label };
			onChange(updated);
			return updated;
		});
	};

	const onPhoneNumberValueChanged = (ev: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = ev.target.value;
		setNewPhoneNumber(prev => {
			const updated = { ...prev, value: newValue };
			onChange(updated);
			return updated;
		});
	};

	return (
		<div className={css(styleSheet.phoneNumberFormContainer)}>
			<PhoneNumberLabelCombobox
				label={newPhoneNumber.label || ''}
				onLabelChange={handleLabelChange}
				styles={[styleSheet.phoneNumberSelectBox]}
			/>

			<div className={css(styleSheet.editInput)}>
				<Input
					autoComplete='off'
					id='edit-entity-phone-number-input'
					value={newPhoneNumber.value}
					onChange={onPhoneNumberValueChanged}
					placeholder='Phone Number'
					type={'tel'}
				/>
			</div>
		</div>
	);
};
